import { useState } from 'react';
import TCHAInvoiceApp from './TCHAInvoiceApp';
import Dashboard from './Dashboard';
import InvoiceList from './InvoiceList';
import './App.css';

function App() {
  const [view, setView] = useState('dashboard'); // 'dashboard' | 'invoiceList' | 'invoiceForm'
  const [editInvoiceId, setEditInvoiceId] = useState(null);

  const goToDashboard = () => {
    setEditInvoiceId(null);
    setView('dashboard');
  };

  const goToInvoiceList = () => {
    setEditInvoiceId(null);
    setView('invoiceList');
  };

  const goToNewInvoice = () => {
    setEditInvoiceId(null);
    setView('invoiceForm');
  };

  const goToEditInvoice = (id) => {
    setEditInvoiceId(id);
    setView('invoiceForm');
  };

  if (view === 'invoiceForm') {
    return (
      <TCHAInvoiceApp
        editInvoiceId={editInvoiceId}
        onBack={editInvoiceId ? goToInvoiceList : goToDashboard}
        backLabel={editInvoiceId ? '← Invoices' : '← Dashboard'}
      />
    );
  }

  if (view === 'invoiceList') {
    return <InvoiceList onBack={goToDashboard} onEditInvoice={goToEditInvoice} />;
  }

  return <Dashboard onNavigateToInvoice={goToNewInvoice} onViewInvoices={goToInvoiceList} />;
}

export default App;
